import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-rail.light.webp";
import imageDark from "../images/national-rail.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-rail",
  displayName: `National Rail`,
  datasetProductCode: `GEOSCAPE RAIL`,
  subtitle: `Detailed Digital Representation of Australian Railway Network`,
  shortDescription: `Rail is a national digital dataset which represents rail tracks including light rail as well as stations across Australia. The Rail dataset has two layers: Railway Lines (lines) and Railway Stations (points). 

This dataset provides an optimised aggregated national view of railway line and station geometry and attribution. The dataset is created from multiple sources including jurisdictional data which is revised regularly and supplied in varying formats and at different levels of quality.`,
  metadata: {
    dateAdded: 1264982400000,
    dataType: ["Points", "Lines"],
    totalFeatureCount: 44929,
    updateFrequency: `As Deemed Necessary`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/rail.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/rail.html`,
  imageLight,
  imageDark,
  searchTags: `National Rail Railways Transportation Infrastructure Logistics Urban Planning`,
  detail: () => import("../details/national-rail").then((m) => m.detail),
};

export default entry;
